
/* styles */
require("!!../../../../../../Users/vbastos/AppData/Roaming/npm/node_modules/front-cli/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":0,\"remove\":true,\"publicPath\":\"../\"}!css-loader?{\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7e4af99a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./header.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?{\"presets\":[[\"C:\\\\Users\\\\vbastos\\\\AppData\\\\Roaming\\\\npm\\\\node_modules\\\\front-cli\\\\node_modules\\\\babel-preset-env\\\\lib\\\\index.js\",{\"targets\":{\"browsers\":[\"ie >= 9\"]},\"modules\":false,\"useBuiltIns\":true,\"debug\":false}]],\"compact\":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./header.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7e4af99a\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./header.vue"),
  /* scopeId */
  "data-v-7e4af99a",
  /* cssModules */
  null
)
Component.options.__file = "C:\\Repositorios\\AGENDA_PREFEITO\\front-end\\application\\views\\commons\\header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e4af99a", Component.options)
  } else {
    hotAPI.reload("data-v-7e4af99a", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./application/views/commons/header.vue
// module id = 374
// module chunks = 1